import { useEffect, useState } from 'react';
import axios from 'axios';

function ClientSystemDownloadSCGViewModel() {
    const [isUAT, setIsUAT] = useState(true);
    const downloadFGUIUrl = isUAT
        ? 'https://scgo365.sharepoint.com/:u:/r/sites/CCSSAPS4Project-FocusOne-Mafuang/Shared%20Documents/FocusOne%20-%20Mafuang/120%20-%20GUI%20Set%20up/FGUI%20UAT2025.zip?csf=1&web=1&e=XDKcLO'
        : 'https://scgo365.sharepoint.com/:f:/s/F1PRODSupport/Eu4hQR_T-qhOjttMikJ_YuQBE_nYkzwWKWj8STtmWiRt_Q';
    const downloadFGUIManualUrl = isUAT
        ? 'https://fgui.s3.ap-southeast-1.amazonaws.com/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89%E0%B8%87_FocusOne_ERP_UAT.pdf'
        : 'https://fgui.s3.ap-southeast-1.amazonaws.com/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89%E0%B8%87_FocusOne_ERP_PRD.pdf';

    useEffect(() => {
        fetchIsUAT();
    }, []);

    const fetchIsUAT = async () => {
        const data = (await axios.get('/v1/app-env')).data;

        setIsUAT(data.app_env === 'UAT');
    };

    return {
        isUAT,
        downloadFGUIUrl,
        downloadFGUIManualUrl
    };
}

export default ClientSystemDownloadSCGViewModel;
